const STEP_ROUTES: Record<number, string> = {
  0: '/signup',
  1: '/signup/otp',
  2: '/signup/company',
  3: '/signup/plans',
  4: '/signup/payment',
};

export { STEP_ROUTES };
